define([
  'dojo/_base/declare',
  'dijit/TitlePane'

], (declare, TitlePane) => {
  return declare('MainPane', [TitlePane], {
    constructor: function () {
    },

    startup: function () {
      this.inherited(arguments);
      this.testButton.startup();
    },

    postCreate: function () {
      this.set({ title: 'Main pane' });
      this.inherited(arguments);
    }
  });
});
